import React from 'react';
import { string, number } from 'prop-types';

import * as helpers from './helpers';

const PencilIcon = ({ color, fillOpacity, ...props }) => (
  <svg {...helpers.getSvgDimensionsProps(props)} {...helpers.getViewBoxProperty(props)} {...props}>
    <path
      fill={color}
      fillOpacity={fillOpacity}
      d="M0 10.5V13H2.5L9.87333 5.62662L7.37333 3.12662L0 10.5ZM11.8067 3.69329C12.0667 3.43329 12.0667 3.01329 11.8067 2.75329L10.2467 1.19329C9.98667 0.933291 9.56667 0.933291 9.30667 1.19329L8.08667 2.41329L10.5867 4.91329L11.8067 3.69329Z"
    />
  </svg>
);

PencilIcon.propTypes = {
  fillOpacity: number,
  color: string.isRequired,
  ...helpers.iconDimensionsPropTypes,
};

PencilIcon.defaultProps = {
  fillOpacity: 0.4,
  ...helpers.getDefaultIconDimensionsProps(13, 13),
  ...helpers.getViewBoxProperty({ width: 13, height: 13 }),
};

export default PencilIcon;



// WEBPACK FOOTER //
// ./src/components/svg-icon/icons/pencil.js